import { LoanService, AuthService } from '@/utils/service'
import Vue from 'vue'

export const applyReady = (isIp) => {
  return new AuthService({
    url: '/wallet/ready',
    method: 'post',
    data: {
      ip: isIp
    }
  })
}
export const giveup = (applyId) => {
  return new LoanService({
    url: '/loan/apply/v2/renounce',
    method: 'post',
    data: {
      applyID: applyId
    }
  })
}
export const applyCredit = (params = {
  position: '0, 0',
  userCookieId: '',
  tdDeviceKey: ''
}) => {
  return new LoanService({
    url: '/loan/app/v4/credit',
    method: 'post',
    data: params
  })
}
export const getApplyInfo = () => {
  return new LoanService({
    url: '/loan/app/v4/info',
    method: 'get'
  })
}
export const saveApplyInfoStep1 = (params = {
  applyId: 0,
  province: '',
  city: '',
  county: '',
  address: '',
  realName: '',
  idCard: ''
}) => {
  const _params = Object.assign({}, params)
  if (_params.applyId > 0) {
    if (_params.realName && _params.realName.length === 0) {
      delete _params.realName
    }
    if (_params.idCard && _params.idCard.length === 0) {
      delete _params.idCard
    }
  } else {
    return Promise.reject({
      status: 400,
      message: '申请数据异常，请刷新重试'
    })
  }
  return new LoanService({
    url: 'loan/app/v4/info/person/step1',
    method: 'post',
    data: _params
  })
}
export const getDict = () => {
  return new LoanService({
    url: '/loan/apply/v2/dict',
    method: 'get'
  })
}
export const saveApplyInfoStep2 = (params = {
  applyId: 0,
  nContractor: '',
  nMobile: '',
  nRelationship: '',
  income: '',
  workExperience: '',
  cardNumber: ''
}) => {
  const _params = Object.assign({}, params)
  return new LoanService({
    url: '/loan/app/v4/info/person/step2',
    method: 'post',
    data: _params
  })
}
export const getValidateUrl = (params = {
  applyId: 0
}) => {
  let data = {
    applyId: params.applyId,
    callbackURL: '/callback/circle/h5?redirectUrl=' + location.href
  };
  if (["idmiao635", "idmiao633"].indexOf(Vue.cookie('partner')) > -1) {
    data.app = 1;
  }
  if (["idmiao633"].indexOf(Vue.cookie('partner')) > -1) {
    data.skin = "hangbanguanjia"
  }
  if (["idmiao634"].indexOf(Vue.cookie('partner')) > -1) {
    data.app = 1;
    data.skin = "sina"
  }

  return new LoanService({
    url: '/loan/auth/v1/3rd/jxl',
    method: 'get',
    data: data
  })
}
export const applyHistory = () => {
  return new LoanService({
    url: '/loan/app/user/v4/list',
    method: 'get'
  })
}
export const getApplyProcess = (params = {
  applyId: 0
}) => {
  return new LoanService({
    url: '/loan/app/v4/credit/status',
    needLoading: false,
    method: 'get',
    data: {
      applyId: params.applyId
    }
  })
}
export const getHistoryDetail = (params = {
  applyId: 0
}) => {
  return new LoanService({
    url: '/loan/loan/v1/detail',
    method: 'get',
    data: {
      applyId: params.applyId
    }
  })
}
export const getLoanSchedule = (params = {
  applyId: 0
}) => {
  return new LoanService({
    url: '/loan/loan/v1/schedule',
    method: 'get',
    data: {
      applyId: params.applyId
    }
  })
}
